export enum ResultCode {
    SUCCESS = 0,
    NOT_FOUND = 1,
    UPDATED = 2,
    REVIEWING = 3,
    REVIEWED = 4,
    ACCESS_DENIED = 5,
    ACCESS_EXPIRED = 6,
    USER_INACTIVE = 7,
    LOCKED = 8,
    DUPLICATED = 9,

    BAD_REQUEST = 9999,
    UNPROCESSABLE_ENTITY = 9999,
    TIMEOUT_ERROR = 9999,
    INTERNAL_SERVER_ERROR = 9999,

    // Missing parameters
    MISSING_CITY_STALLID = 1000,
    MISSING_SPMS_ROAD_NO = 1001,
    MISSING_SPACE_NO = 1002,
    MISSING_METER_POSITION = 1003,
    MISSING_IP_TYPE = 1004,
    MISSING_AUTHENTICATION = 1005,
    MISSING_SYSTEM_TYPE = 1006,
    MISSING_ACCOUNT = 1007,
    MISSING_PASSWORD = 1008,
    MISSING_OLD_PASSWORD = 1009,
    MISSING_NEW_PASSWORD = 1010,
    MISSING_TOKEN = 1011,

    MISSING_EVT_DESC = 1012,
    MISSING_CITY_DESC = 1013,
    MISSING_UPDATE_TYPE = 1014,
    MISSING_UPDATE_STATUS = 1015,
    MISSING_DECLINE_TYPE = 1016,
    MISSING_DECLINE_REASON = 1017,
    MISSING_UPDATE_USER_ID = 1018,
    MISSING_UPDATE_TIME = 1019,
    MISSING_DISTRICT_ZIPCODE = 1020,
    MISSING_DISTRICT_ZIPCODE_DESC = 1021,
    MISSING_RATE_TYPE = 1022,
    MISSING_RATE_TYPE_DESC = 1023,
    MISSING_METER_TYPE = 1024,
    MISSING_METER_TYPE_DESC = 1025,
    MISSING_MM_TYPE = 1026,
    MISSING_MM_MODE = 1027,
    MISSING_MM_MODE_DESC = 1028,
    MISSING_MM_ENABLE_DEF_VAL = 1029,
    MISSING_BATTERY_DETECT_FG = 1030,
    MISSING_BATTERY_DETECT_FG_DESC = 1031,
    MISSING_SPACE_RANGE_TYPE = 1032,
    MISSING_SPACE_RANGE_TYPE_DESC = 1033,
    MISSING_SPACE_TYPE = 1034,
    MISSING_SPACE_TYPE_DESC = 1035,
    MISSING_SUBNET_IP = 1036,
    MISSING_NETMASK_IP = 1037,
    MISSING_PMA_ROAD_CODE = 1038,
    MISSING_SPMS_ZONE_NO = 1039,
    MISSING_SPMS_ZONE_NO_SNUM = 1040,
    MISSING_IP_PARTITION = 1041,
    MISSING_CONFIG_NO = 1042,
    MISSING_CLASS_C_NETWORK_SNUM = 1043,
    MISSING_SERVER_TYPE = 1044,
    MISSING_SERVER_CATEGORY = 1045,
    MISSING_SERVER_IP = 1046,
    MISSING_SERVER_PORT = 1047,
    MISSING_SERVER_DESC = 1048,
    MISSING_SERVER_USERNAME = 1049,
    MISSING_SERVER_PASSWD = 1050,
    MISSING_NOTE_DESC = 1051,
    MISSING_IP_FOR_SPACE_NO = 1052,
    MISSING_MEASURE_FOR_SPACE_NO = 1053,
    MISSING_X_DESC = 1054,
    MISSING_Y_DESC = 1055,
    MISSING_W_DESC = 1056,
    MISSING_H_DESC = 1057,
    MISSING_SPMS_ROAD_DESC = 1058,
    MISSING_SPMS_ROAD_DTL_DESC = 1059,
    MISSING_ROAD_LENGTH = 1060,
    MISSING_GOV_ANNOUNCE_SPACE_AMOUNT = 1061,
    MISSING_SURVEY_SPACE_AMOUNT = 1062,
    MISSING_HANDOVER_SPACE_AMOUNT = 1063,
    MISSING_SURVEY_HICAM_SPACE_AMOUNT = 1064,
    MISSING_FACING_ROAD_FG = 1065,
    MISSING_ONEWAY_FG = 1066,
    MISSING_CONSTRUCTION_STAGE_DESC = 1067,
    MISSING_GOLIVE_DATE = 1068,
    MISSING_VPN_ACCOUNT = 1069,
    MISSING_HN_ACCOUNT = 1070,
    MISSING_HN_PASSWD = 1071,
    MISSING_HN_START_IP = 1072,
    MISSING_HN_END_IP = 1073,
    MISSING_HN_NETMASK_IP = 1074,
    MISSING_HN_GATEWAY_ROUTER_IP = 1075,
    MISSING_HN_DNS_IP = 1076,
    MISSING_HN_ADSL_ADDR = 1077,
    MISSING_HN_BAUD_RATE = 1078,
    MISSING_HN_CONFIG_NOTE_DESC01 = 1079,
    MISSING_HN_CONFIG_NOTE_DESC02 = 1080,
    MISSING_HN_CONFIG_NOTE_DESC03 = 1081,
    MISSING_NETWORK_IP_CONFIG = 1082,
    MISSING_METER_NO_DESC = 1083,
    MISSING_INPUT_FILE_NAME = 1084,
    MISSING_INPUT_USER_ID = 1085,
    MISSING_INPUT_TIME = 1086,
    MISSING_SELECTED_FG = 1087,
    MISSING_DEV_TYPE = 1088,
    MISSING_DEV_TYPE_DESC = 1089,
    MISSING_DEV_PART_TYPE = 1090,
    MISSING_DEV_PART_TYPE_DESC = 1091,
    MISSING_DEV_COMP_TYPE = 1092,
    MISSING_DEV_COMP_TYPE_DESC = 1093,
    MISSING_QTY_TYPE = 1094,
    MISSING_QTY_TYPE_DESC = 1095,
    MISSING_UNIT_SYMBOL = 1096,
    MISSING_UNIT_DESC = 1097,
    MISSING_THR_TYPE = 1098,
    MISSING_THR_VAL = 1099,
    MISSING_THR_OP = 1100,
    MISSING_ALERT_FG = 1101,
    MISSING_EVT_TYPE = 1102,
    MISSING_EVT_TYPE_DESC = 1103,
    MISSING_EVT_CODE = 1104,
    MISSING_EVT_CODE_DESC = 1105,
    MISSING_DEV_STATE_CODE = 1106,
    MISSING_DEV_STATE_CODE_DESC = 1107,
    MISSING_DEV_STATE_CODE_DTL_DESC = 1108,
    MISSING_WORK_MODE = 1109,
    MISSING_ZGW_TICKET_ID = 1110,
    MISSING_EVT_NTFY_TYPE = 1111,
    MISSING_EVT_NTFY_TYPE_DESC = 1112,
    MISSING_EVT_NTFY_SRC = 1113,
    MISSING_EVT_NTFY_SRC_DESC = 1114,
    MISSING_ORDER_ID = 1116,
    MISSING_ACTIV_NO = 1117,
    MISSING_EVT_NTFY_USER = 1118,
    MISSING_LOC_NO = 1119,
    MISSING_EVT_LOCS = 1120,
    MISSING_DEV_EVT_STATE_VAL = 1121,
    MISSING_PKNG_PLATE_NO = 1122,
    MISSING_EVT_NTFY_DESC = 1123,
    MISSING_EVT_NTFY_TIME = 1124,
    MISSING_EVT_TIME = 1125,
    MISSING_ACTIV_TYPE = 1126,
    MISSING_ACTIV_DESC = 1127,
    MISSING_MEM_ID = 1128,
    MISSING_MEM_NAME = 1129,
    MISSING_DEPT_ID = 1130,
    MISSING_DEPT_NAME = 1131,
    MISSING_DEPT_GRP_ID = 1132,
    MISSING_DEPT_GRP_NAME = 1133,
    MISSING_USER_ID = 1134,
    MISSING_USER_NAME = 1135,
    MISSING_CONT_PERSON = 1136,
    MISSING_TEL_NO = 1137,
    MISSING_FAX_NO = 1138,
    MISSING_ADDR = 1139,
    MISSING_EMAIL = 1140,
    MISSING_NICKNAME = 1141,
    MISSING_USER_PASSWD = 1142,
    MISSING_JOB_TITLE = 1143,
    MISSING_MGR_USER_ID = 1144,
    MISSING_SUB_MGR_USER_ID = 1145,
    MISSING_INACTIVE_FG = 1146,
    MISSING_EXP_TIME = 1147,
    MISSING_RES_GRP_ID = 1148,
    MISSING_RES_GRP_NAME = 1149,
    MISSING_RES_ID = 1150,
    MISSING_RES_NAME = 1151,
    MISSING_ACT_ID = 1152,
    MISSING_ACT_NAME = 1153,
    MISSING_ACT_TYPE = 1154,
    MISSING_SYS_TYPE = 1155,
    MISSING_ICON_NAME = 1156,
    MISSING_PRGM_NAME = 1157,
    MISSING_POS = 1158,
    MISSING_NO_LIMIT_FG = 1159,
    MISSING_LOCKOUT_FLAG = 1160,
    MISSING_EVT_CAT = 1161,
    MISSING_EVT_CAT_DESC = 1162,
    MISSING_SLA_ID = 1163,
    MISSING_SLA_DESC = 1164,
    MISSING_GOAL_DUR = 1165,
    MISSING_DDL_DUR = 1166,
    MISSING_PASSED_DDL_DUR = 1167,
    MISSING_START_TIME = 1168,
    MISSING_END_TIME = 1169,
    MISSING_ACTIV_USER_ID = 1170,
    MISSING_ACTIV_STATUS = 1171,
    MISSING_ASGN_USER_ID = 1172,
    MISSING_PKNG_USAGE_DUR = 1173,
    MISSING_PKNG_FEE = 1174,
    MISSING_BANK_CODE = 1175,
    MISSING_BANK_ACCOUNT = 1176,
    MISSING_USER_TEL_NO = 1177,
    MISSING_USER_EMAIL = 1178,
    MISSING_PKNG_RCPT_CODE = 1179,
    MISSING_PKNG_RCPT_PLATE_NO = 1180,
    MISSING_PKNG_RCPT_USAGE_DUR = 1181,
    MISSING_PKNG_RCPT_PMT_TYPE_DESC = 1182,
    MISSING_PKNG_RCPT_FEE_PAYABLE = 1183,
    MISSING_PKNG_RCPT_FEE_PAID = 1184,

    // NEW
    MISSING_OP_NO = 1300,
    MISSING_OP_DESC = 1301,
    MISSING_TERM_NO = 1302,
    MISSING_TERM_DESC = 1303,
    MISSING_MGR_TERM_NO = 1304,
    MISSING_MGR_TERM_DESC = 1305,
    MISSING_PLATE_NO = 1306,
    MISSING_PLATE_NO_DESC = 1307,
    MISSING_MER_ID = 1308,
    MISSING_MER_DESC = 1309,
    MISSING_TICKET_NO = 1310,
    MISSING_ACHIEVE_TIME = 1311,
    MISSING_OLD_DEV_ID = 1312,
    MISSING_NEW_DEV_ID = 1313,
    MISSING_WO_STS_TYPE_DESC = 1314,
    MISSING_ACTIV_STS_TYPE_DESC = 1315,
    MISSING_WO_ACTIV_STS_TYPE_DESC = 1316,
    MISSING_WO_STS_TYPE = 1317,
    MISSING_WO_ACTIV_STS_TYPE = 1318,
    MISSING_TIME_FG = 1319,
    MISSING_VEH_CNT = 1320,

    // Invalid parameters
    INVALID_CITY_STALLID = 2000,
    INVALID_SPMS_ROAD_NO = 2001,
    INVALID_SPACE_NO = 2002,
    INVALID_METER_POSITION = 2003,
    INVALID_IP_TYPE = 2004,
    INVALID_AUTHENTICATION = 2005,
    INVALID_SYSTEM_TYPE = 2006,
    INVALID_ACCOUNT = 2007,
    INVALID_PASSWORD = 2008,
    INVALID_OLD_PASSWORD = 2009,
    INVALID_NEW_PASSWORD = 2010,
    INVALID_TOKEN = 2011,

    INVALID_EVT_DESC = 2012,
    INVALID_CITY_DESC = 2013,
    INVALID_UPDATE_TYPE = 2014,
    INVALID_UPDATE_STATUS = 2015,
    INVALID_DECLINE_TYPE = 2016,
    INVALID_DECLINE_REASON = 2017,
    INVALID_UPDATE_USER_ID = 2018,
    INVALID_UPDATE_TIME = 2019,
    INVALID_DISTRICT_ZIPCODE = 2020,
    INVALID_DISTRICT_ZIPCODE_DESC = 2021,
    INVALID_RATE_TYPE = 2022,
    INVALID_RATE_TYPE_DESC = 2023,
    INVALID_METER_TYPE = 2024,
    INVALID_METER_TYPE_DESC = 2025,
    INVALID_MM_TYPE = 2026,
    INVALID_MM_MODE = 2027,
    INVALID_MM_MODE_DESC = 2028,
    INVALID_MM_ENABLE_DEF_VAL = 2029,
    INVALID_BATTERY_DETECT_FG = 2030,
    INVALID_BATTERY_DETECT_FG_DESC = 2031,
    INVALID_SPACE_RANGE_TYPE = 2032,
    INVALID_SPACE_RANGE_TYPE_DESC = 2033,
    INVALID_SPACE_TYPE = 2034,
    INVALID_SPACE_TYPE_DESC = 2035,
    INVALID_SUBNET_IP = 2036,
    INVALID_NETMASK_IP = 2037,
    INVALID_PMA_ROAD_CODE = 2038,
    INVALID_SPMS_ZONE_NO = 2039,
    INVALID_SPMS_ZONE_NO_SNUM = 2040,
    INVALID_IP_PARTITION = 2041,
    INVALID_CONFIG_NO = 2042,
    INVALID_CLASS_C_NETWORK_SNUM = 2043,
    INVALID_SERVER_TYPE = 2044,
    INVALID_SERVER_CATEGORY = 2045,
    INVALID_SERVER_IP = 2046,
    INVALID_SERVER_PORT = 2047,
    INVALID_SERVER_DESC = 2048,
    INVALID_SERVER_USERNAME = 2049,
    INVALID_SERVER_PASSWD = 2050,
    INVALID_NOTE_DESC = 2051,
    INVALID_IP_FOR_SPACE_NO = 2052,
    INVALID_MEASURE_FOR_SPACE_NO = 2053,
    INVALID_X_DESC = 2054,
    INVALID_Y_DESC = 2055,
    INVALID_W_DESC = 2056,
    INVALID_H_DESC = 2057,
    INVALID_SPMS_ROAD_DESC = 2058,
    INVALID_SPMS_ROAD_DTL_DESC = 2059,
    INVALID_ROAD_LENGTH = 2060,
    INVALID_GOV_ANNOUNCE_SPACE_AMOUNT = 2061,
    INVALID_SURVEY_SPACE_AMOUNT = 2062,
    INVALID_HANDOVER_SPACE_AMOUNT = 2063,
    INVALID_SURVEY_HICAM_SPACE_AMOUNT = 2064,
    INVALID_FACING_ROAD_FG = 2065,
    INVALID_ONEWAY_FG = 2066,
    INVALID_CONSTRUCTION_STAGE_DESC = 2067,
    INVALID_GOLIVE_DATE = 2068,
    INVALID_VPN_ACCOUNT = 2069,
    INVALID_HN_ACCOUNT = 2070,
    INVALID_HN_PASSWD = 2071,
    INVALID_HN_START_IP = 2072,
    INVALID_HN_END_IP = 2073,
    INVALID_HN_NETMASK_IP = 2074,
    INVALID_HN_GATEWAY_ROUTER_IP = 2075,
    INVALID_HN_DNS_IP = 2076,
    INVALID_HN_ADSL_ADDR = 2077,
    INVALID_HN_BAUD_RATE = 2078,
    INVALID_HN_CONFIG_NOTE_DESC01 = 2079,
    INVALID_HN_CONFIG_NOTE_DESC02 = 2080,
    INVALID_HN_CONFIG_NOTE_DESC03 = 2081,
    INVALID_NETWORK_IP_CONFIG = 2082,
    INVALID_METER_NO_DESC = 2083,
    INVALID_INPUT_FILE_NAME = 2084,
    INVALID_INPUT_USER_ID = 2085,
    INVALID_INPUT_TIME = 2086,
    INVALID_SELECTED_FG = 2087,
    INVALID_DEV_TYPE = 2088,
    INVALID_DEV_TYPE_DESC = 2089,
    INVALID_DEV_PART_TYPE = 2090,
    INVALID_DEV_PART_TYPE_DESC = 2091,
    INVALID_DEV_COMP_TYPE = 2092,
    INVALID_DEV_COMP_TYPE_DESC = 2093,
    INVALID_QTY_TYPE = 2094,
    INVALID_QTY_TYPE_DESC = 2095,
    INVALID_UNIT_SYMBOL = 2096,
    INVALID_UNIT_DESC = 2097,
    INVALID_THR_TYPE = 2098,
    INVALID_THR_VAL = 2099,
    INVALID_THR_OP = 2100,
    INVALID_ALERT_FG = 2101,
    INVALID_EVT_TYPE = 2102,
    INVALID_EVT_TYPE_DESC = 2103,
    INVALID_EVT_CODE = 2104,
    INVALID_EVT_CODE_DESC = 2105,
    INVALID_DEV_STATE_CODE = 2106,
    INVALID_DEV_STATE_CODE_DESC = 2107,
    INVALID_DEV_STATE_CODE_DTL_DESC = 2108,
    INVALID_WORK_MODE = 2109,
    INVALID_ZGW_TICKET_ID = 2110,
    INVALID_EVT_NTFY_TYPE = 2111,
    INVALID_EVT_NTFY_TYPE_DESC = 2112,
    INVALID_EVT_NTFY_SRC = 2113,
    INVALID_EVT_NTFY_SRC_DESC = 2114,
    INVALID_ORDER_ID = 2116,
    INVALID_ACTIV_NO = 2117,
    INVALID_EVT_NTFY_USER = 2118,
    INVALID_LOC_NO = 2119,
    INVALID_EVT_LOCS = 2120,
    INVALID_DEV_EVT_STATE_VAL = 2121,
    INVALID_PKNG_PLATE_NO = 2122,
    INVALID_EVT_NTFY_DESC = 2123,
    INVALID_EVT_NTFY_TIME = 2124,
    INVALID_EVT_TIME = 2125,
    INVALID_ACTIV_TYPE = 2126,
    INVALID_ACTIV_DESC = 2127,
    INVALID_MEM_ID = 2128,
    INVALID_MEM_NAME = 2129,
    INVALID_DEPT_ID = 2130,
    INVALID_DEPT_NAME = 2131,
    INVALID_DEPT_GRP_ID = 2132,
    INVALID_DEPT_GRP_NAME = 2133,
    INVALID_USER_ID = 2134,
    INVALID_USER_NAME = 2135,
    INVALID_CONT_PERSON = 2136,
    INVALID_TEL_NO = 2137,
    INVALID_FAX_NO = 2138,
    INVALID_ADDR = 2139,
    INVALID_EMAIL = 2140,
    INVALID_NICKNAME = 2141,
    INVALID_USER_PASSWD = 2142,
    INVALID_JOB_TITLE = 2143,
    INVALID_MGR_USER_ID = 2144,
    INVALID_SUB_MGR_USER_ID = 2145,
    INVALID_INACTIVE_FG = 2146,
    INVALID_EXP_TIME = 2147,
    INVALID_RES_GRP_ID = 2148,
    INVALID_RES_GRP_NAME = 2149,
    INVALID_RES_ID = 2150,
    INVALID_RES_NAME = 2151,
    INVALID_ACT_ID = 2152,
    INVALID_ACT_NAME = 2153,
    INVALID_ACT_TYPE = 2154,
    INVALID_SYS_TYPE = 2155,
    INVALID_ICON_NAME = 2156,
    INVALID_PRGM_NAME = 2157,
    INVALID_POS = 2158,
    INVALID_NO_LIMIT_FG = 2159,
    INVALID_LOCKOUT_FLAG = 2160,
    INVALID_EVT_CAT = 2161,
    INVALID_EVT_CAT_DESC = 2162,
    INVALID_SLA_ID = 2163,
    INVALID_SLA_DESC = 2164,
    INVALID_GOAL_DUR = 2165,
    INVALID_DDL_DUR = 2166,
    INVALID_PASSED_DDL_DUR = 2167,
    INVALID_START_TIME = 2168,
    INVALID_END_TIME = 2169,
    INVALID_ACTIV_USER_ID = 2170,
    INVALID_ACTIV_STATUS = 2171,
    INVALID_ASGN_USER_ID = 2172,
    INVALID_PKNG_USAGE_DUR = 2173,
    INVALID_PKNG_FEE = 2174,
    INVALID_BANK_CODE = 2175,
    INVALID_BANK_ACCOUNT = 2176,
    INVALID_USER_TEL_NO = 2177,
    INVALID_USER_EMAIL = 2178,
    INVALID_PKNG_RCPT_CODE = 2179,
    INVALID_PKNG_RCPT_PLATE_NO = 2180,
    INVALID_PKNG_RCPT_USAGE_DUR = 2181,
    INVALID_PKNG_RCPT_PMT_TYPE_DESC = 2182,
    INVALID_PKNG_RCPT_FEE_PAYABLE = 2183,
    INVALID_PKNG_RCPT_FEE_PAID = 2184,

    // NEW
    INVALID_OP_NO = 2300,
    INVALID_OP_DESC = 2301,
    INVALID_TERM_NO = 2302,
    INVALID_TERM_DESC = 2303,
    INVALID_MGR_TERM_NO = 2304,
    INVALID_MGR_TERM_DESC = 2305,
    INVALID_PLATE_NO = 2306,
    INVALID_PLATE_NO_DESC = 2307,
    INVALID_MER_ID = 2308,
    INVALID_MER_DESC = 2309,
    INVALID_TICKET_NO = 2310,
    INVALID_ACHIEVE_TIME = 2311,
    INVALID_OLD_DEV_ID = 2312,
    INVALID_NEW_DEV_ID = 2313,
    INVALID_WO_STS_TYPE_DESC = 2314,
    INVALID_ACTIV_STS_TYPE_DESC = 2315,
    INVALID_WO_ACTIV_STS_TYPE_DESC = 2316,
    INVALID_WO_STS_TYPE = 2317,
    INVALID_WO_ACTIV_STS_TYPE = 2318,
    INVALID_TIME_FG = 2319,
    INVALID_VEH_CNT = 2320,

    // Unique parameters
    UNIQUE_USER = 5000,
    UNIQUE_CITY = 5001,
    UNIQUE_DISTRICT = 5002,
    UNIQUE_RATE_TYPE = 5003,
    UNIQUE_METER_TYPE = 5004,
    UNIQUE_MM_MODE = 5005,
    UNIQUE_BATTERY_DETECT = 5006,
    UNIQUE_SPACE_RANGE_TYPE = 5007,
    UNIQUE_SPACE_TYPE = 5008,
    UNIQUE_ROAD = 5009,
    UNIQUE_ROAD_ZONE = 5010,
    UNIQUE_NETWORK_IP = 5011,
    UNIQUE_NETWORK_IP_CONFIG = 5012,
    UNIQUE_SERVER = 5013,
    UNIQUE_ROAD_ZONE_SERVER = 5014,
    UNIQUE_ROAD_ZONE_METER_IP = 5015,
    UNIQUE_ROAD_ZONE_METER_MEASURE = 5016,
    UNIQUE_CONSTRUCTION_STAGE = 5017,
    UNIQUE_DEV_TYPE = 5018,
    UNIQUE_DEV_PART_TYPE = 5019,
    UNIQUE_DEV_COMP_TYPE = 5020,
    UNIQUE_QTY_TYPE = 5021,
    UNIQUE_DEV_EVT_THR = 5022,
    UNIQUE_EVT_TYPE = 5023,
    UNIQUE_EVT_CODE = 5024,
    UNIQUE_DEV_STATE_CODE = 5025,
    UNIQUE_EVT_NTFY_TYPE = 5026,
    UNIQUE_EVT_NTFY_SRC = 5027,
    UNIQUE_EVT_SLA = 5028,
    UNIQUE_RES_GROUP = 5029,
    UNIQUE_RES = 5030,
    UNIQUE_ACTION = 5031,
    UNIQUE_MEMBER = 5032,
    UNIQUE_DEPT = 5033,
    UNIQUE_DEPT_GROUP = 5034,
    UNIQUE_USER_GROUP = 5035,
    UNIQUE_SVC_REQ = 5036,
    UNIQUE_WORK_ORD = 5037,
    UNIQUE_WORK_ORD_ACTIV = 5038,
    UNIQUE_MEMBER_PERM = 5039,
    UNIQUE_DEPT_PERM = 5040,
    UNIQUE_DEPT_GROUP_PERM = 5041,
    UNIQUE_USER_ACCESS = 5042,
    UNIQUE_EVT_CAT = 5043,
    UNIQUE_SVC_REQ_LOC = 5044,
    UNIQUE_OPERATOR_NO = 5106, // not exist
    UNIQUE_TERM_NO = 5107, // not exist
    UNIQUE_PLATE_NO = 5108, // not exist
    UNIQUE_MERCHANT_ID = 5109, // not exist

    UNIQUE_OP = 5100,
    UNIQUE_TERM = 5101,
    UNIQUE_VEH = 5102,
    UNIQUE_MER = 5103,
    UNIQUE_WO_STS_TYPE = 5104,
    UNIQUE_WO_ACTIV_STS_TYPE = 5105,
}
